export default __webpack_public_path__ + "static/media/perfecto_flush_3.13652428.jpeg";